module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tile",
    class: {
      empty: _vm.tile.isEmpty
    },
    style: (_vm.tile.styles),
    on: {
      "click": _vm.move
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ca2fdf9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tile.vue
// module id = 34
// module chunks = 1